<template>
    <v-dialog v-model="dialog" width="500">
        <template v-slot:activator="{on, attrs}">
            <v-btn test-tag="tag-2"
                class="mr-3"
                :color="btn.color"
                v-bind="attrs"
                v-on="on"
            >
                <T>{{ btn.text }}</T>
            </v-btn>
        </template>
        <v-card>
            <v-card-title test-tag="tag-5"><T>{{ label }}</T></v-card-title>
            <v-card-text><T>Заказ будет запущен в работу.</T><br><T>Принять заказ?</T></v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn test-tag="tag-3" color="black" text @click="dialog = false"><T>Отмена</T></v-btn>
                <v-btn test-tag="tag-4" :color="btn.color" text @click="onSubmit"><T>{{ btn.text }}</T></v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default{
    props:{
        btn: Object,
        label: String,
        text: String
    }, 
    data: () => ({
        dialog: false
    }),
    methods:{
        onSubmit(){
            this.$emit('onSubmit')
            this.dialog = false
        }
    }
}
</script>